<script lang="ts" setup>
import type { AgentOnPage } from '@@/shared/agent/api-types';

defineProps<{
  agent: AgentOnPage
}>();
</script>

<template>
  <IadWrapper class="py-l md:py-2xl">
    <IadTitle
      :text="$t(`agent.valuation.sold.latest_transactions.title`)"
      variant="large"
      class="py-s md:py-m"
    />
    <IadScrollable variant="dense">
      <PropertyCardSold
        v-for="property of agent.latestTransactions?.sold"
        :key="property.propertyListingRef"
        :property="property"
      />
    </IadScrollable>
  </IadWrapper>
</template>
